const ACTIVITY_KEY = 'datacord.sessionActivityAt';

export function markSessionActivity() {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
}

export function clearSessionActivity() {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(ACTIVITY_KEY);
}

export function sessionIdleLimitMs(): number {
  if (typeof localStorage === 'undefined') return 60 * 60 * 1000;
  const token = localStorage.getItem('accessToken');
  if (!token) return 60 * 60 * 1000;
  try {
    const segment = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(segment));
    const minutes = Number(payload?.user?.sessionPolicy?.accessMinutes);
    if (Number.isFinite(minutes) && minutes > 0) return minutes * 60 * 1000;
  } catch {
    return 60 * 60 * 1000;
  }
  return 60 * 60 * 1000;
}

export function isSessionIdle(): boolean {
  if (typeof localStorage === 'undefined') return false;
  const raw = localStorage.getItem(ACTIVITY_KEY);
  if (!raw) return false;
  const last = Number(raw);
  if (!Number.isFinite(last)) return false;
  return Date.now() - last >= sessionIdleLimitMs();
}

export function sessionUserIsActive(): boolean {
  return !isSessionIdle();
}
